module.exports = __webpack_public_path__ + "static/media/ITAAIR.b2e4d61c.svg";